<div class="container-fluid">
    <select class="form-control w-100" name="answer_{{name}}"
            [(ngModel)]="values"
            multiple                    
            [disabled]="summaryMode"
            (ngModelChange)="onClick()"
            required>
        <option *ngFor="let option of filter(options)" [value]="toValue(option)">{{toLabel(option)}}</option>
    </select>
    <mat-error *ngIf="question.invalid">required</mat-error>
</div>

